
app.directive('emptyToNull', function () {
  // sometimes backend wants value to be null instead of ''
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      ctrl.$parsers.push(function (viewValue) {
        if (viewValue === '') {
          return null;
        }

        return viewValue;
      });
    }
  };
});